import { Injectable } from '@angular/core';
import { createStore, filterNil } from '@ngneat/elf';
import {
  deleteAllEntities,
  selectAllEntities,
  setEntities,
  withEntities,
} from '@ngneat/elf-entities';
import { ApiCountriesAdapterService } from '@fullyops/data/countries/api-adapter.service';
import { Country } from '@fullyops/data/countries/country';

@Injectable({ providedIn: 'root' })
export class CountriesService {
  constructor(private api: ApiCountriesAdapterService) {}

  private countriesStore = createStore(
    { name: 'countries' },
    withEntities<Country>({ idKey: 'id' }),
  );

  countries$ = this.countriesStore.pipe(filterNil(), selectAllEntities());

  refreshAll() {
    this.api.getCountries().subscribe((res: Country[]) => {
      this.countriesStore.update(setEntities(res));
    });
  }

  clear(): void {
    this.countriesStore.update(deleteAllEntities());
  }
}
